import {
  SET_TOGGLED_MONTHS,
  TOGGLE_MONTH,
  TOGGLE_MONTH_SESSIONS,
  TOGGLE_SOLD_OUT_SESSIONS,
} from './_types';

export default {
  [SET_TOGGLED_MONTHS]: (state, toggledMonths) => {
    state.toggledMonths = toggledMonths;
  },
  [TOGGLE_MONTH]: ({ toggledMonths }, name) => {
    const isToggled = toggledMonths.includes(name);
    if (isToggled) {
      toggledMonths.splice(toggledMonths.indexOf(name), 1);
    } else {
      toggledMonths.push(name);
    }
  },
  [TOGGLE_MONTH_SESSIONS]: ({ toggledMonthSessions }, name) => {
    const isToggled = toggledMonthSessions.includes(name);
    if (isToggled) {
      toggledMonthSessions.splice(toggledMonthSessions.indexOf(name), 1);
    } else {
      toggledMonthSessions.push(name);
    }
  },
  [TOGGLE_SOLD_OUT_SESSIONS]: ({ toggledSoldOutSessions }, name) => {
    const isToggled = toggledSoldOutSessions.includes(name);
    if (isToggled) {
      toggledSoldOutSessions.splice(toggledSoldOutSessions.indexOf(name), 1);
    } else {
      toggledSoldOutSessions.push(name);
    }
  },
};
